import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { gsap } from "gsap";   
import { Subscription } from 'rxjs';
import { ModalMessageService } from '../../../services/modal-message.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports:[
    CommonModule,
  ],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, AfterViewInit {
  tlModal:any;
  timeTl:any = 1;
  easeTl:any = "power3.out";
  offTimeTl:any = '0.85'
  tituloModal: string = '';
  parrafoModal: string = '';
  viewModal: boolean = false;
  icoSrc: string = '';
  foo: boolean = false;

  constructor(private modalMessageService: ModalMessageService) {}

  ngOnInit() {}

  private modalSubscription: Subscription[] = [];

  ngAfterViewInit(){
    this.modalSubscription.push(
      this.modalMessageService.tituloModal$.subscribe(titulo => this.tituloModal = titulo),
      this.modalMessageService.parrafoModal$.subscribe(parrafo => this.parrafoModal = parrafo),
      this.modalMessageService.icoSrc$.subscribe(icoSrc => this.icoSrc = icoSrc),
      this.modalMessageService.foo$.subscribe(foo => this.foo = foo),
      this.modalMessageService.viewModal$.subscribe(view => {
        this.viewModal = view;

        this.openModal();
        
      })
      
    );

  }

  openModal():void{
    this.tlModal = gsap.timeline({paused: true });
    this.tlModal.fromTo( '.modal' ,0.5,{y:50, opacity:0},{y:0, opacity:1,ease: this.easeTl});
    this.tlModal.fromTo(['.head', '.body', '.foo'],this.timeTl, {y:20,opacity:0},{y:0,opacity:1, stagger: 0.15, ease: this.easeTl},'-=0.4');
    this.tlModal.play();
  }


  ngOnDestroy() {
    // Desuscribirse cuando el componente se destruye
    this.modalSubscription.forEach(sub => sub.unsubscribe());
  }

  // Función para cerrar el modal
  cerrarModal() {
    this.modalMessageService.closeModal(); // Llama al servicio para cerrar el modal
  }

}
